import { Icon } from '@/general/Icons/Icon';
import { FC } from 'react';

export const Chevron: FC = () => (
  <span className="relative flex size-6 items-center justify-center text-tex-def-tie1 transition-colors duration-200 group-hover/chevron:text-tex-inv-tie1">
    <span className="absolute top-1/2 left-1/2 size-4 -translate-x-1/2 -translate-y-1/2 rounded-full bg-for-pri-sub transition-colors duration-200 group-hover/chevron:bg-for-pri-bas" />
    <Icon name="caret-right-filters" />
  </span>
);
